import React from 'react'
import { withRouter } from 'react-router'
import { BASE_API } from '../../../api'
import gwasviz_multi_trait_conf from './conf/gwasviz_multi_trait_conf'
import './css/locuszoom.css'

class MultiTraitLocuszoom extends React.Component {
    state = {
        config: {
            // locuszoom 图默认展示区间
            species: gwasviz_multi_trait_conf.species,
            query_trait: gwasviz_multi_trait_conf.query_trait,
            query_chr: gwasviz_multi_trait_conf.query_chr,
            query_loc_start: gwasviz_multi_trait_conf.query_loc_start,
            query_loc_end: gwasviz_multi_trait_conf.query_loc_end, 
        },
        plot: ''
    }

    // componentWillReceiveProps 生命周期函数已不建议使用，所以改用此函数
    static getDerivedStateFromProps(props, state) {
        if ((JSON.stringify(props.locuszoom_config) !== JSON.stringify(state.config)) && state.plot !== '') {
            const { species, query_trait, query_chr, query_loc_start, query_loc_end } = props.locuszoom_config
            const plot = MultiTraitLocuszoom.populateLocuszoomScatter(species, query_trait, query_chr, query_loc_start, query_loc_end)

            return {
                config: {
                    species: species,
                    query_trait: query_trait,
                    query_chr: query_chr,
                    query_loc_start: query_loc_start,
                    query_loc_end: query_loc_end
                },
                plot: plot
            }
        }

        return {}
    }

    /**
     * 
     * @param {*} species 
     * @param {*} chr 
     * @param {*} start 
     * @param {*} end 
     * @param {*} phenos phenos格式参照如下: 
     *  phenos = [
            { namespace: "fasting_glucose", title: "Fasting glucose meta-analysis", color: "rgb(212, 63, 58)", study_id: 31 },
            { namespace: "fasting_insulin", title: "Fasting insulin meta-analysis", color: "rgb(238, 162, 54)", study_id: 32 },
            { namespace: "triglycerides", title: "Triglycerides meta-analysis", color: "rgb(92, 184, 92)", study_id: 29 },
            { namespace: "cholesterol", title: "Total cholesterol meta-analysis", color: "rgb(53, 126, 189)", study_id: 30 }
        ];
     */
    static populateLocuszoomScatter = (species, query_trait, chr, start, end) => {
        let phenos = []
        const pheno_color = ['#E41A1C', '#377EB8', '#4DAF4A', '#984EA3', '#FF7F00']
        query_trait.forEach(function(trait, index){
            let pheno_namespace = Math.random().toString(36).substring(8)
            let pheno = {namespace: pheno_namespace, title: trait, color: pheno_color[index], study_id: index+1}
            phenos.push(pheno)
        })

        /******************** populate GWAS LocusZoom ********************/
        const LocusZoom = window.LocusZoom
        const gene_api = `${BASE_API}/gwasviz/retrive_gene/species/${species}/chr/${chr}/start/${start}/end/${end}`
        let data_sources = new LocusZoom.DataSources().add("gene", ["CottonGeneLZ", { url: gene_api }])

        // Build the base layout
        let association_panel_mods = {
            data_layers: [
                LocusZoom.Layouts.get("data_layer", "significance", { name: "Line of GWAS Significance" }),
            ],
            toolbar: LocusZoom.Layouts.get("panel", "cotton_association")["toolbar"]
        }
        
        association_panel_mods.toolbar.widgets.push({
            type: "data_layers",
            position: "right",
            statuses: ["faded", "hidden"]
        });
        
        let layout = {
            state: {chr: chr, start: start, end: end},
            width: 800,
            responsive_resize: true,
            panels: [
                LocusZoom.Layouts.get("panel", "cotton_association", association_panel_mods),
                LocusZoom.Layouts.get("panel", "cotton_genes", { namespace: { "gene": "gene" } })
            ],
            toolbar: LocusZoom.Layouts.get("toolbar", "cotton_standard_plot")
        }
        

        // Define a set of studies/phenotypes and loop through them to add a data source and data layer for each one
        phenos.forEach(function(pheno){
            const assoc_api = `${BASE_API}/gwasviz/retrive_assoc/species/${species}/trait/${pheno.title}/chr/${chr}/start/${start}/end/${end}`
            data_sources.add(pheno.namespace, ["CottonAssociationLZ", {url: assoc_api}])
            let association_data_layer_mods = {
                namespace: { "assoc": pheno.namespace },
                id: "associationpvalues_" + pheno.namespace,
                name: pheno.title,
                point_shape: "circle",
                point_size: 40,
                color: pheno.color,
                legend: [
                    { shape: "circle", color: pheno.color, size: 40, label: pheno.title, class: "lz-data_layer-scatter" },
                ],
                fields: [pheno.namespace+":variant", pheno.namespace+":position", pheno.namespace+":log_pvalue", pheno.namespace+":log_pvalue|logtoscinotation", pheno.namespace+":ref_allele"],
                tooltip: {
                    closable: true,
                    show: { or: ["highlighted", "selected"] },
                    hide: { and: ["unhighlighted", "unselected"] },
                    html: "<strong>" + pheno.title + "</strong><br>"
                        + "<strong>{{" + pheno.namespace + ":variant}}</strong><br>"
                        + "P Value: <strong>{{" + pheno.namespace + ":log_pvalue|logtoscinotation}}</strong><br>"
                        + "Ref. Allele: <strong>{{" + pheno.namespace + ":ref_allele}}</strong><br>"
                }
            }
            layout.panels[0].data_layers.push(LocusZoom.Layouts.get("data_layer", "association_pvalues", association_data_layer_mods))
        });

        // Generate the LocusZoom plot
        let plot = LocusZoom.populate("#lz-plot", data_sources, layout)
        
        // Add a basic loader to each panel (one that shows when data is requested and hides when one rendering)
        plot.layout.panels.forEach(function(panel){
            plot.panels[panel.id].addBasicLoader()
        })

        return plot
    }

    componentDidMount() {
        const { species, query_trait, query_chr, query_loc_start, query_loc_end } = this.props.locuszoom_config
        let plot = MultiTraitLocuszoom.populateLocuszoomScatter(species, query_trait, query_chr, query_loc_start, query_loc_end)

        this.setState({
            config: {
                species: species,
                query_trait: query_trait,
                query_chr: query_chr,
                query_loc_start: query_loc_start,
                query_loc_end: query_loc_end
            },
            plot: plot
        })
    }

    render() {
        return (
            <div id="lz-plot"></div>
        )
    }
}

export default withRouter(MultiTraitLocuszoom)